import "./styleSheets/landingPage.css";
import ImageCarousel from "./imageGrid";
import React, { useEffect, useState } from "react";

const MehndiPage = () => {
  const [smImages, setSmImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    const loadImages = async () => {
      try {
        setIsLoading(true);
        setHasError(false);
        const response = await fetch("/mehndiImages/list.json", {
          signal: controller.signal,
        });
        if (!response.ok) {
          throw new Error(`Failed to load images: ${response.status}`);
        }
        const data = await response.json();
        if (Array.isArray(data)) {
          setSmImages(data.map((file) => `/mehndiImages/${file}`));
        } else {
          setSmImages([]);
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Could not load mehndi image list.", error);
          setSmImages([]);
          setHasError(true);
        }
      } finally {
        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      }
    };

    loadImages();
    return () => controller.abort();
  }, []);

  return (
    <div className="mehndiPage">
      <div className="info-section">
        <div className="landingBox">
          <h1>Mehndi</h1>
          <p style={{ fontSize: "large", padding: "0px 50px" }}>
            Indulge in the beauty of 100% natural, freshly prepared mehndi, free
            from harsh chemicals. Whether it's for your special day or a festive
            celebration, I specialize in both Bridal and guest mehndi art,
            tailored to perfection for any occasion.
            <br />
            <br />
            Bridal mehndi is a cherished journey, meticulously crafted and
            utterly rewarding. Elevate your bridal experience with personalized
            touches – imagine adorable mementos intricately woven into your
            design, from charming portraits of the happy couple to iconic
            landmarks symbolizing your unique love story.
            <br />
            <br />
            Let me transform your mehndi experience into a cherished memory,
            where every stroke tells a tale of love and celebration.
          </p>
          <div className="styled-line"></div>
          <h2>Client/Model Work</h2>
          {isLoading && <p>Loading gallery...</p>}
          {hasError && (
            <p>We could not load images right now. Please refresh and try again.</p>
          )}
          <ImageCarousel slides={smImages} />
        </div>
      </div>
    </div>
  );
};

export default MehndiPage;
